import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/statics/a.png'
import _imports_1 from '@/assets/statics/b.png'
import _imports_2 from '@/assets/statics/c.png'
import _imports_3 from '@/assets/statics/d.png'
import _imports_4 from '@/assets/statics/ef.png'
import _imports_5 from '@/assets/statics/g.png'
import _imports_6 from '@/assets/statics/h.png'
import _imports_7 from '@/assets/statics/i.png'
import _imports_8 from '@/assets/statics/j.png'


const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = { class: "static" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "A. The generated date of datasets, each dot is a dataset, colored by the species and sized by the number of spots, the y-axis is the number of experiments in the dataset, and the x-axis is the release time of the dataset. The line-plot shows the cumulative number of experiments across time. The timeline-plot shows the number of experiments of different categories of spatial technologies over time. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "B. The distribution of experiments by species.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_1
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "C. The distribution of experiments by technologies. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_2
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "D. The distribution of experiments by tissue types.")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_3
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "EF. The distribution of used technologies in human and mouse studies. ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_4
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "G. The relationships between the number of spots and the number of molecular features. Each dot is a dataset, colored by the categories of spatial transcriptomics technologies and sized by the number of experiments. Dashed circles of different colors are different clusters. Black solid lines indicate the spatial technologies of datasets. Red arrow indicates a representative MERFISH dataset. ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_5
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "H. The distribution of experiments by different quality controls. ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_6
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "I. The percentage of SE features grouped by different technologies. Each point in the boxplot is the percentage of SE features (molecular features with Moran’s I >0) of one experiment.")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_7
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "J. Boxplots showing the sparsity of expression matrix grouped by different technologies. Each point in the boxplot is the sparsity (the percentage of zeros in expression matrix) of one experiment. ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_8
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_el_divider),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_5,
          _createVNode(_component_el_divider),
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_7,
          _createVNode(_component_el_divider),
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_9,
          _createVNode(_component_el_divider),
          _hoisted_10
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_11,
          _createVNode(_component_el_divider),
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_13,
          _createVNode(_component_el_divider),
          _hoisted_14
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_15,
          _createVNode(_component_el_divider),
          _hoisted_16
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_17,
          _createVNode(_component_el_divider),
          _hoisted_18
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _hoisted_19,
          _createVNode(_component_el_divider),
          _hoisted_20
        ]),
        _: 1
      })
    ])
  ]))
}